import React from "react";
import { injectGlobal, } from "styled-components";

import * as v from "./vars";
import * as m from "./mixins";
import { objMap, } from "../../lib/util";

// --------------------------------------------------

export default () => injectGlobal`
	@import url('https://fonts.googleapis.com/css?family=Inconsolata:400,700');

	*, *:before, *:after {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
	}

	html {
		min-height: 100%;
		position: relative;
	}

	body {
		background: ${v.colors.bg};
		font-family: Inconsolata, monospace;
		${m.bpEach("font-size", v.font.size)}
		color: ${v.colors.text};
		margin: 0;
		overflow-y: scroll;
	}

	a,
	a:hover,
	a:visited {
		color: ${v.colors.text};
		text-decoration: none;
	}

	p, h1, h2, h3, h4 {
		${m.bpEach("margin", objMap(v.font.size, (key, val) => val + " 0"))}
	}

	img {
		vertical-align: bottom;
	}
`;


// WEBPACK FOOTER //
// ./src/components/style/globalStyles.js